import Config from "../../config/Config";
const axios = require("axios");
const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  const token = localStorage.getItem("token_redux");
  return token ? token.replaceAll('"', "") : "";
};

export const getDataSaving = (callerId) => {
  return axios.get(`${baseUrlDev}katalis/saving/user/balance`, {
    params: {
      callerId,
    },
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getAccountSaving = (callerId, coa, configId) => {
  return axios.get(`${baseUrlDev}katalis/saving/user`, {
    params: {
      callerId,
      coa,
      configId,
    },
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getSummarySaving = (callerId, coaCode, configId) => {
  return axios.get(`${baseUrlDev}katalis/saving/user/summary`, {
    params: { callerId, coaCode, configId },
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getMutationSaving = (
  callerId,
  coaCode,
  configId,
  date,
  sort,
  page = 0,
  size = 10,
) => {
  return axios.get(`${baseUrlDev}katalis/saving/user/mutation`, {
    params: { callerId, coaCode, configId, date, page, size, sort },
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getDetailMutationSaving = (id) => {
  return axios.get(`${baseUrlDev}katalis/saving/user/mutation/${id}`, {
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getConfigSavings = (id) => {
  return axios.get(`${baseUrlDev}katalis/saving/user/config/${id}`, {
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const sumbitSaving = (data) => {
  let url = baseUrlDev + "katalis/saving/user";
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};
